module.exports = __webpack_public_path__ + "static/media/BannerServicios_NubePlaneta.ace9bdc5.png";